import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { ajaxFeedbackStatusFilter, ajaxFeedbackSearch, setQuery } from './redux/FeedbackRedux';

class DynamicTitle extends React.Component {
	render () {
		var timestring = "";
		if (this.props.timeframe == "today") {
			timestring = __("From Today");
		} else if (this.props.timeframe == "yesterday") {
			timestring = __("From Yesterday");
		} else if (this.props.timeframe == "weekToDate") {
			timestring = __("From This Week");
		} else if (this.props.timeframe == "monthToDate") {
			timestring = __("From This Month");
		} else if (this.props.timeframe == "lifetime") {
			timestring = __("From All-Time");
		} else if (this.props.timeframe == "last30") {
			timestring = __("From Last 30 Days");
		}

		var other = "";
		if(this.props.other == "chats_requested") {
			other = __("Chats Requested");
		} else if (this.props.other == "chats_started") {
			other = __("Chats Started");
		} else if (this.props.other == "links_sent") {
			other = __("Review Links Sent");
		} else if (this.props.other == "chats_waiting") {
			other = __("Chats Still Open");
		}

		return (
		<span>{(this.props.status != null && this.props.status !="null" ? this.props.status : __("All"))  + ' ' +  __("Feedbacks") + other}</span>
		);
	}
}

function mapStateToProps(state) {
	return { status:state.status,other:state.other_filter, departments:state.departments }
  }

  export default connect(mapStateToProps)(DynamicTitle)
